/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useState, useEffect, useMemo, useRef, memo } from 'react'
import { useMergeState } from 'irmlib/hooks'
// import PropTypes from 'prop-types'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
// import * as localGdeTransactionLite from '../../../services/firestore/localGdeTransactionsLite'
// import * as constants from '../../../irmlib/src/common/constants'
// import LockIcon from '@material-ui/icons/Lock'
import { closeGeneralDialog, openGeneralDialog } from '../../../irmlib/src/containers'
import { Box, Typography, Paper, TextField, Tooltip, Button, Fade } from '@mui/material'
import { ContainedButton, Label, OutlinedButton, ThemeButton } from '../../../irmlib/src/components/Controls'
import GroupedAssetType from '../../../irmlib/src/components/Controls/GroupedAssetType'
import { dateValidatePattern, errorToast, successToast, validateField } from '../../../common/functions'
// import RequestTemplateFormat from '../Template/RequestListTemplate'
import { XDivider, YDivider } from '../../../irmlib/src/styles'
// import { QCReferenceImageChange } from './LocalMenuActivities'
import { CancelButton } from '../../../irmlib/src/components/FormControls'
import { getUser } from '../../../redux/global'
import { t } from 'i18next'

const initialData = {
  imageResponse: {},
  fieldDetails: [],
  dateFields: {},
  wmsInstance: '',
  newTemplateId: false,
  imgData: {},
  selectedSkpBoxnum: '',
  activityData: {},
  isQCCompleted: false,
  assignedWorker: ''
  // templateLocked: {},
  // lockedData: {},
}

// const VerticalDivider = () => <YDivider height="30px" />

// const BottomPaddedButton = props =>
//   <>
//     <ThemeButton {...props} />
//     <VerticalDivider />
//   </>

const FieldsInfoContainerD = memo(({ activityId, imageData, imgId, imageDocId, handleNext, handleHardRedirect, disableFields, handleLoadingController }) => {
  const [state, setState, getState] = useMergeState(initialData)
  const [keyStrokes, setKeyStrokes] = useState(0)
  const [startTime] = useState(Date.now())
  // const [selectedTemplate, setSelectedTemplate] = useState(false)
  // const [refImage, setRefImage] = useState(false)
  const userval = getUser()
  const { country, workerId, district, email } = userval
  const inputRefs = useRef([])
  const handleSubmitRef = useRef(null)
  // const tableRef = useRef()

  useEffect(() => {
    const fetchImages = () => {
      try {
        //setBusy()
        console.log('doc id -->', imageDocId)
        if (imageData && imageData.imgResponse) {
          setState({ isQCCompleted: imageData?.isProcessed, assignedWorker: imageData?.lockedBy })
          let template
          let imgResponse
          if (imageData?.isProcessed) {
            imgResponse = imageData?.imgResponseQC
            template = imageData?.template
          } else {
            imgResponse = imageData?.imgResponse
            template = imageData?.template
          }
          // const templateLoc = imageData?.templateLocked
          // const lockedValues = Object.fromEntries(
          //   Object.entries(templateLoc).map(([key, value]) => [key, value.lockedValue])
          // )
          // setState({ lockedData: lockedValues, templateLocked: templateLoc, fieldDetails: { ...template, ...templateLoc } })
          setState({ imgData: imageData, imageResponse: imgResponse, wmsInstance: imageData?.wmsCode, temp: template, fieldDetails: { ...template } })
        } 
        // else if (imageDocId) {
        //   const imgData = await localGdeTransactions.getQcImgData(imageDocId)
        //   setState({ isQCCompleted: imgData?.isProcessed, assignedWorker: imgData?.lockedBy })
        //   let template
        //   let imgResponse
        //   if (imgData?.isProcessed) {
        //     imgResponse = imgData?.imgResponseQC
        //     template = imgData?.template
        //   } else {
        //     imgResponse = imgData?.imgResponse
        //     template = imgData?.template
        //   }
        //   // const templateLoc = imgData?.templateLocked
        //   // const lockedValues = Object.fromEntries(
        //   //   Object.entries(templateLoc).map(([key, value]) => [key, value.lockedValue])
        //   // )
        //   // setState({ lockedData: lockedValues, templateLocked: templateLoc, fieldDetails: { ...template, ...templateLoc } })
        //   setState({ imgData: imgData, imageResponse: imgResponse, wmsInstance: imgData?.wmsCode, temp: template, fieldDetails: { ...template } })
        // }
      } catch (error) {
        console.error('Error fetching images:', error)
      } 
      //finally {
        // clearBusy()
      // }
    }

    fetchImages()
  }, [activityId, imageData, imageDocId])
  // }, [activityId, imageData, imageDocId, selectedTemplate, refImage ])


  // useEffect(async () => {
  //   if (!(Object.keys(getState()?.imgData).length === 0)) {
  //       const boxData = await localGdeTransactions.getActivityByID(getState()?.imgData?.activityId)
  //       setState({
  //         activityData: boxData,
  //         selectedSkpBoxnum: getState()?.imgData?.skpBoxNbr
  //       })
  //   }
  // }, [getState()?.imgData])

  useEffect(() => {
    const clickListener = () => setKeyStrokes(prev => prev + 1)
    window.addEventListener('click', clickListener)
    return () => {
      window.removeEventListener('click', clickListener)
    }
  }, [])

  // const getTemplate = async () => {
  //   let templateData = await localGdeTransactions.getTemplateById_SC(getState()?.activityData?.templateId)
  //   templateData = templateData.data()
  //   const data = {
  //     accountLevel1: templateData?.accountLevel1 || '',
  //     accountLevel2: templateData?.accountLevel2 || '',
  //     accountLevel3: templateData?.accountLevel3 || '',
  //     assetType: templateData?.assetType || '',
  //     templateType: templateData?.templateType || '',
  //     wmsInstance: templateData?.wmsCode || '',
  //   }

  //   const templates = await localGdeTransactions.getRequests(data)
  //   const templateList = []
  //   templates.forEach((doc) => {
  //     templateList.push(doc.data())
  //   })
  //   setState({
  //     templateData: templateList,
  //   })
  // }

  const rejectionFlow = async (value, imgDocId, customReason = '', skipConfirmation = false) => {
    // Skip confirmation dialog if customReason is provided (from "Other" option) or skipConfirmation is true
    if (skipConfirmation || customReason) {
      handleReject(value, imgDocId, customReason)
      return
    }
    openGeneralDialog({
      title: <Label noTranslate={true}>{t('options.rejectImg')}</Label>,
      message: t('options.rejectImgMsg'),
      buttons: <>
        <CancelButton onClick={closeTemplateDialog} />
        <XDivider width='10px' />
        <ContainedButton onClick={() => handleReject(value, imgDocId, customReason)} >buttons.yes</ContainedButton>
      </>
    })
  }

  // Helper function to get sorted folder entries with consistent ordering
  const getSortedFolderEntries = (data) => {
    return Object.entries(data).sort(([nameA], [nameB]) => {
      // Try numeric comparison first, then fall back to string comparison
      const numA = parseInt(nameA, 10)
      const numB = parseInt(nameB, 10)
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB
      }
      return nameA.localeCompare(nameB)
    })
  }

  const handleReject = async (value, imgDocId, customReason = '') => {
    // setBusy()
    handleLoadingController(true)
    const imgResult = {}
    const newRes = {}
    // Use responseData consistently with sorted order to ensure we're saving the user's current edits
    getSortedFolderEntries(responseData).forEach(([folderName, fields]) => {
      imgResult[folderName] = {}
      newRes[folderName] = {}
      Object.entries(fields).forEach(([fieldKey, fieldData]) => {
        imgResult[folderName][fieldKey] = fieldData
        newRes[folderName][fieldKey] = { value: fieldData }
      })
    })
    const endTime = Date.now()
    const totalDuration = Math.floor((endTime - startTime) / 1000)
    
    // Use custom reason if "Other" is selected, otherwise use the value
    const exceptionValue = value === 'Other' && customReason ? `Other: ${customReason}` : value
    
    const data = {
      imgResponseQC: newRes,
      isProcessed: true,
      isRejected: true,
      onHold: false,
      qcInfo: {
        exception: exceptionValue,
        hitl: {
          correctedKeystrokes: keyStrokes,
          duration: totalDuration,
          user: email,
        },
        status: 'Failure',
        statusCode: 'NA',
      },
      updatedTS: (new Date()).toISOString(),
    }
    const imgData = {
      idpResponse: imgResult,
      isProcessed: true,
      isIdpFail: true,
      updatedTS: (new Date()).toISOString(),
      processedAt: (new Date()).toISOString(),
      idp: {
        exception: exceptionValue,
        hitl: {
          correctedKeystrokes: keyStrokes,
          duration: totalDuration,
          user: email,
        },
        status: 'Failure',
        statusCode: 'NA',
      },
      status: 'HITL Reject'
    }
    await localGdeTransactions.updateQCImgDoc(imgDocId, data, imgId, imgData)
    handleLoadingController(false)
    closeGeneralDialog()
    handleNext()
    // clearBusy()
  }

  // const getTemplateFields = async () => {
  //   setBusy()
  //   await getTemplate()
  //   const fields = getState()?.templateData
  //   fields.sort((a, b) => {
  //     return (new Date(b.createdTS)) - (new Date(a.createdTS))
  //   })
  //   const resultPromises = fields.map(doc => {
  //     const templateFields = Object.keys(doc.template).map((key) => {
  //       const data = `${key} (${doc.template[key].fieldId})`
  //       return data
  //     })

  //     return localGdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
  //       return {
  //         requestId: doc.templateId,
  //         requestFields: templateFields,
  //         customTemplateName: doc.customTemplateName,
  //         createdBy: createdBy,
  //         createdOn: doc.createdTS,
  //         imgReference: doc.imgReference
  //       }
  //     })
  //   })
  //   const result = await Promise.all(resultPromises)
  //   clearBusy()
  //   return result
  // }

  // const handleSelectedRefImage = async (imgRef, imgRefURI) => {
  //   const data = {
  //     imgReference: imgRef,
  //     imgReferenceURI: imgRefURI
  //   }
  //   await localGdeTransactions.updateQCImgDoc(imageDocId, data)
  //   successToast({ message: t('toast.RefImgChangedSucessfully'), title: t('toast.success') }, 5)
  // }

  // const openUpdateRefImageDialog = (rowData) => {
  //   openGeneralDialog({
  //     title: t('templates.refImageUpdate'),
  //     maxWidth: 'lg',
  //     noTranslateTitle: true,
  //     message: <QCReferenceImageChange rowData={rowData} selectedReferenceData={handleSelectedRefImage} setRefImage={setRefImage} onClose={closeTemplateDialog} />,
  //     closeX: false
  //   })
  // }

  // const onTemplateSelection = async () => {
  //   if (getState()?.activityData?.templateId && getState()?.newTemplateId) {
  //     setBusy()
  //     const emptyResponse = Object.fromEntries(Object.keys(getState()?.imgData?.imgResponse).map(key => [key, {}]))
  //     await localGdeTransactions.updateQCImgData(imageDocId, getState()?.newTemplateId, emptyResponse)
  //     setState({ imageResponse: emptyResponse })
  //     setSelectedTemplate(getState()?.newTemplateId)
  //     successToast({ message: t('toast.templateChangedSucessfully'), title: t('toast.success') }, 5)
  //     closeGeneralDialog()
  //     clearBusy()
  //   } else {
  //     closeGeneralDialog()
  //   }
  // }

  const selectChange = async (e) => {
    const value = e.target.value
    if (value === 'Image is Wrong' || value === 'Image is Blur' || value === 'Template Fields are not present') {
      rejectionFlow(value, imageDocId)
    } else if (value === 'Other') {
      openOtherRejectionDialog()
    }
  }

  const openOtherRejectionDialog = () => {
    // Created a component that manages its own state for the dialog
    const RejectionReasonDialog = () => {
      const [reason, setReason] = useState('')
      const reasonRef = useRef(null)

      useEffect(() => {
        // Focusing the input when dialog opens
        if (reasonRef.current) {
          setTimeout(() => {
            reasonRef.current?.focus()
          }, 100)
        }
      }, [])

      const handleConfirm = () => {
        if (!reason.trim()) {
          errorToast({ 
            message: t('toast.rejectionReason'), 
            title: t('toast.error'), 
            autoHideDuration: 3000, 
            isBlocking: false 
          })
          return
        }
        closeGeneralDialog()
        // Skip confirmation dialog since user already confirmed by entering reason and clicking reject
        rejectionFlow('Other', imageDocId, reason, true)
      }

      const handleCancel = () => {
        closeGeneralDialog()
      }

      const REASON_MAX_LENGTH = 50

      return (
        <Box sx={{ padding: 2, minWidth: '400px' }}>
          <TextField
            inputRef={reasonRef}
            fullWidth
            multiline
            rows={4}
            variant='outlined'
            placeholder={t('toast.rejectionReason')}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            disabled={disableFields}
            inputProps={{ maxLength: REASON_MAX_LENGTH }}
            helperText={`${reason.length}/${t('Search.fiftyCharacters')}`}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && e.ctrlKey && reason.trim()) {
                handleConfirm()
              }
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, marginTop: 2 }}>
            <CancelButton onClick={handleCancel} />
            <XDivider width='10px' />
            <ContainedButton 
              onClick={handleConfirm}
              disabled={!reason.trim()}
            >
              {t('buttons.reject')}
            </ContainedButton>
          </Box>
        </Box>
      )
    }

    openGeneralDialog({
      title: <Label noTranslate={true}>{t('toast.rejectionReason')}</Label>,
      message: <RejectionReasonDialog />,
      buttons: <></>, // Buttons are now inside the component
      closeX: true
    })
  }


  const closeTemplateDialog = () => {
    closeGeneralDialog()
  }

  // const handleTemplateChange = async () => {
  //   openGeneralDialog({
  //     title: t('smartCatalog.templates'),
  //     maxWidth: 'lg',
  //     noTranslateTitle: true,
  //     message: <ContentForDialogBox />,
  //     buttons: <ButtonsForTemplateAssign
  //       closeTemplateDialog={closeTemplateDialog} onNewTemplateSelection={onTemplateSelection}
  //     />,
  //     closeX: true
  //   })
  // }

  // const ButtonsForTemplateAssign = props =>
  //   <>
  //     <BottomPaddedButton color='primary' variant='outlined' onClick={props.closeTemplateDialog}>buttons.cancel</BottomPaddedButton>
  //     <BottomPaddedButton color='primary' variant='contained' onClick={props.onNewTemplateSelection}>buttons.cancelAndGoBack</BottomPaddedButton>
  //   </>

  // ButtonsForTemplateAssign.propTypes = {
  //   onNewTemplateSelection: PropTypes.func,
  //   closeTemplateDialog: PropTypes.func
  // }

  // const onCheckBoxSelection = async (requestId) => {
  //   if (requestId) {
  //     setState({
  //       newTemplateId: requestId,
  //     })
  //   } else {
  //     setState({
  //       newTemplateId: false,
  //     })
  //   }
  // }

  // const ContentForDialogBox = () => {
  //   return (
  //     <>
  //       <RequestTemplateFormat
  //         tableRef={tableRef}
  //         getPageData={getTemplateFields}
  //         title={getState()?.activityData?.templateName}
  //         isEdit={false}
  //         getState={getState}
  //         selectedRecord={onCheckBoxSelection}
  //         currentTemplateId={getState()?.activityData?.templateId}
  //         fromMultiReqs={false}
  //         reportFor={'multiRequestSelection'}
  //       />
  //     </>
  //   )
  // }

  const newData = useMemo(() => {
    const merged = {}
    const allKeys = [...new Set([
      ...Object.keys(getState()?.temp || {}),
      // ...Object.keys(getState()?.templateLocked || {})
    ])]
    // Sort folder names consistently to maintain order
    const sortedFolderEntries = Object.entries(getState()?.imageResponse || {}).sort(([nameA], [nameB]) => {
      // Try numeric comparison first, then fall back to string comparison
      const numA = parseInt(nameA, 10)
      const numB = parseInt(nameB, 10)
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB
      }
      return nameA.localeCompare(nameB)
    })
    for (const [folderName, folderFields] of sortedFolderEntries) {
      const folderData = {}
      for (const field of allKeys) {
        // const isLocked = Boolean(getState()?.templateLocked[field])
        const hasValue = folderFields?.[field]?.value !== undefined
        folderData[field] = hasValue
          ? folderFields?.[field].value : ''
        // : isLocked ? getState()?.templateLocked[field]?.lockedValue ?? ''
        // : ''
      }
      merged[folderName] = folderData
    }
    return merged
  }, [getState()?.imageResponse, getState()?.temp])
  // }, [getState()?.imageResponse, getState()?.temp, selectedTemplate])

  // }, [getState()?.imageResponse, getState()?.temp, getState()?.templateLocked])

  const [responseData, setResponseData] = useState(newData)
  const [errors, setErrors] = useState({})


  useEffect(() => {
    if (newData && Object.keys(newData)?.length > 0) {
      setResponseData(newData)
    }
  }, [newData])

  // Validate all fields when responseData is initialized or updated
  useEffect(() => {
    const fieldDetails = getState()?.fieldDetails
    const wmsInstance = getState()?.wmsInstance
    
    if (responseData && Object.keys(responseData)?.length > 0 && fieldDetails) {
      const validateAllFields = async () => {
        const validationErrors = {}
        const validationPromises = []

        // Build result object for validation
        const result = {}
        Object.entries(responseData).forEach(([fName, fields]) => {
          result[fName] = {}
          Object.entries(fields).forEach(([fKey, fieldData]) => {
            result[fName][fKey] = fieldData
          })
        })

        // Validate all fields
        getSortedFolderEntries(responseData).forEach(([folderName, fields]) => {
          Object.entries(fields).forEach(([fieldKey, fieldValue]) => {
            if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
              const errorKey = `${folderName}.${fieldKey}`
              validationPromises.push(
                validateField(folderName, fieldValue, fieldKey, fieldDetails, wmsInstance, result)
                  .then((errorMsg) => {
                    if (errorMsg) {
                      validationErrors[errorKey] = errorMsg
                    }
                  })
                  .catch((err) => {
                    console.error('Validation error:', err)
                  })
              )
            }
          })
        })

        // Wait for all validations to complete
        await Promise.all(validationPromises)
        
        // Set all errors at once
        setErrors((prev) => ({
          ...prev,
          ...validationErrors
        }))
      }

      validateAllFields()
    }
  }, [responseData, state.fieldDetails, state.wmsInstance])

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus()
    }
  }, [])

  // Update ref whenever handleSubmit changes
  useEffect(() => {
    handleSubmitRef.current = handleSubmit
  })

  // Keyboard shortcut: Ctrl+Enter to save and move to next image
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check for Ctrl+Enter (or Cmd+Enter on Mac)
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        // Only trigger if fields are not disabled and QC is not completed
        // getState() is called here to get current state at the time of keypress
        const currentState = getState()
        if (!disableFields && !currentState.isQCCompleted && (!currentState.assignedWorker || currentState.assignedWorker === workerId)) {
          e.preventDefault()
          e.stopPropagation()
          // Use ref to ensure we call the latest handleSubmit function
          if (handleSubmitRef.current) {
            handleSubmitRef.current(false)
          }
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [disableFields, workerId, getState])

  const getFieldFormat = (fieldKey) => {
    return getState()?.fieldDetails?.[fieldKey]?.format ?? getState()?.temp?.[fieldKey]?.format ?? ''
  }

  const isDateField = (fieldKey) => {
    const format = getFieldFormat(fieldKey)
    return Object.keys(dateValidatePattern).includes(format)
  }

  const formatDateInputValue = (value, isDeleting = false) => {
    const digitsOnly = value.replace(/\D/g, '').slice(0, 8)
    if (digitsOnly.length < 2) return digitsOnly
    if (digitsOnly.length === 2) return isDeleting ? digitsOnly : `${digitsOnly}/`
    if (digitsOnly.length < 4) return `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`
    if (digitsOnly.length === 4) return isDeleting ? `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}` : `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}/`
    return `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2, 4)}/${digitsOnly.slice(4)}`
  }

  const getDateCursorPosition = (rawValue, formattedValue, cursorPosition = 0) => {
    const digitsBeforeCursor = rawValue.slice(0, cursorPosition).replace(/\D/g, '').length

    if (digitsBeforeCursor <= 0) {
      return 0
    }

    let digitsSeen = 0
    for (let i = 0; i < formattedValue.length; i++) {
      if (/\d/.test(formattedValue[i])) {
        digitsSeen += 1
      }

      if (digitsSeen === digitsBeforeCursor) {
        let nextPosition = i + 1
        if (formattedValue[nextPosition] === '/') {
          nextPosition += 1
        }
        return nextPosition
      }
    }

    return formattedValue.length
  }


  const handleChange = async (folderName, fieldKey, newValue) => {
    setKeyStrokes(prev => prev + 1)
    setResponseData((prev) => {
      const updated = {
        ...prev,
        [folderName]: {
          ...prev[folderName],
          [fieldKey]: newValue,
        }
      }
      // Build result with updated data for validation
      const result = {}
      Object.entries(updated).forEach(([fName, fields]) => {
        result[fName] = {}
        Object.entries(fields).forEach(([fKey, fieldData]) => {
          result[fName][fKey] = fieldData
        })
      })
      // Validate with updated data asynchronously
      validateField(folderName, newValue, fieldKey, getState()?.fieldDetails, getState()?.wmsInstance, result).then((errorMsg) => {
        const errorKey = `${folderName}.${fieldKey}`
        setErrors((prev) => ({
          ...prev,
          [errorKey]: errorMsg,
        }))
      }).catch((err) => {
        console.error('Validation error:', err)
      })
      return updated
    })
  }

  const handleDateFieldChange = (e, folderName, fieldKey) => {
    const input = e.target
    const previousValue = responseData?.[folderName]?.[fieldKey] ?? ''
    const inputType = e?.nativeEvent?.inputType ?? ''
    const isDeleting = inputType.startsWith('delete') || input.value.length < previousValue.length
    const formatted = formatDateInputValue(input.value, isDeleting)
    const nextCursorPosition = getDateCursorPosition(input.value, formatted, input.selectionStart ?? 0)

    handleChange(folderName, fieldKey, formatted)

    requestAnimationFrame(() => {
      if (document.activeElement === input) {
        input.setSelectionRange(nextCursorPosition, nextCursorPosition)
      }
    })
  }


  const handleKeyDown = (e, index) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const totalInputs = inputRefs?.current.length
      const nextIndex = (index + 1) % totalInputs
      const nextInput = inputRefs?.current[nextIndex]
      if (nextInput) {
        nextInput?.focus()
      }
    }
  }

  const handleHold = async () => {
    try {
      // setBusy()
      handleLoadingController(true)
      const data = {
        updatedTS: (new Date()).toISOString(),
        onHold: true
      }
      await localGdeTransactions.updateQCImgDoc(imageDocId, data)
      successToast({message : t('toast.imageHoldSuccess'), autoHideDuration:2000})
      handleLoadingController(false)
      handleNext()
    } catch (err) {
      handleLoadingController(false)
      errorToast({message: t('toast.imageHoldFailure'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false})
      console.log('failure while putting image on hold->', err)
    }
    // finally{
    //   handleLoadingController(false)
    //   // clearBusy()
    // }
  }

  const handleSubmit = async (back) => {
    if (Object.keys(errors).length === 0 || Object.values(errors).every(val => !val)) {
      // setBusy()
      handleLoadingController(true)
      const result = {}
      const imgResult = {}
      // Use sorted order to ensure consistent folder ordering when saving
      getSortedFolderEntries(responseData).forEach(([folderName, fields]) => {
        result[folderName] = {}
        imgResult[folderName] = {}
        Object.entries(fields).forEach(([fieldKey, fieldData]) => {
          result[folderName][fieldKey] = { value: fieldData }
          imgResult[folderName][fieldKey] = fieldData
        })
      })
      const endTime = Date.now()
      const totalDuration = Math.floor((endTime - startTime) / 1000)
      const data = {
        imgResponseQC: result,
        isProcessed: true,
        isApproved: true,
        onHold: false,
        qcInfo: {
          exception: '',
          hitl: {
            correctedKeystrokes: keyStrokes,
            duration: totalDuration,
            user: email,
          },
          status: 'Success',
          statusCode: 'NA',
        },
        updatedTS: (new Date()).toISOString(),
      }
      const imgData = {
        idpResponse: imgResult,
        isProcessed: true,
        updatedTS: (new Date()).toISOString(),
        processedAt: (new Date()).toISOString(),
        idp: {
          exception: '',
          hitl: {
            correctedKeystrokes: keyStrokes,
            duration: totalDuration,
            user: email,
          },
          status: 'Success',
          statusCode: 'NA',
        },
        status: 'uploadPending'
      }
      await localGdeTransactions.updateQCImgDoc(imageDocId, data, imgId, imgData)
      successToast({message : t('jobStatusObj.completedQC'), autoHideDuration:2000})

      if (back) {
         handleLoadingController(false)
        handleHardRedirect()
        //clearBusy()
      } else {
         handleLoadingController(false)
        handleNext()
        //clearBusy()
      }
    } else {
      errorToast({ message: t('toast.validationsTxt'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    }
  }

  const options = {
    // 1: {
    //   isActive: true,
    //   name: "Reference Image Change",
    //   sequence: 1,
    //   subAssetTypes: {
    // 1: {
    //   isActive: true,
    //   name: "Change Template",
    //   sequence: 1
    // },
    // 1: {
    //   isActive: true,
    //   name: "Change Reference Image",
    //   sequence: 1
    // }
    //   }
    // },
    1: {
      isActive: true,
      name: "Rejection",
      sequence: 1,
      subAssetTypes: {
        1: {
          isActive: true,
          name: "Image is Wrong",
          sequence: 1
        },
        2: {
          isActive: true,
          name: "Image is Blur",
          sequence: 2
        },
        3: {
          isActive: true,
          name: "Template Fields are not present",
          sequence: 3,
        },
        4: {
          isActive: true,
          name: "Other",
          sequence: 4
        },
      }
    },
  }

  return (
    <Box sx={{ maxHeight: '60vh', padding: 2, opacity: disableFields ? 0.6 : 1 }}>
      {getSortedFolderEntries(responseData).map(([folderName, fields], folderIndex) => {
        // Sort fields alphabetically by fieldKey
        const sortedFields = Object.entries(fields).sort(([keyA], [keyB]) => {
          return keyA.localeCompare(keyB)
        })

        return (
          <Box key={folderName} sx={{ marginBottom: 4 }}>
            <Typography variant='h6' sx={{ textAlign: 'left', fontWeight: 'bold', marginBottom: 1 }}>
              {`${t('smartCatalogLocal.folder')} ${folderIndex + 1}`}
            </Typography>
            <Paper variant='outlined' sx={{ padding: 2 }}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  borderBottom: '1px solid #ccc',
                  paddingBottom: 1,
                  marginBottom: 1
                }}
              >
                <Typography variant='h7' sx={{ textAlign: 'left', fontWeight: 'bold', marginBottom: 1 }}>{t('smartCatalogLocal.templateFields')}
                </Typography>
                <Typography variant='h7' sx={{ textAlign: 'left', fontWeight: 'bold', marginBottom: 1 }}>{t('smartCatalogLocal.value')}</Typography>
              </Box>
              {sortedFields.map(([fieldKey, fieldValue], fieldIndex) => {
                // Get confidence value from imgResponse object for each field
                const imgResponseConfidence = getState()?.imageResponse[folderName]?.[fieldKey]?.confidence ?? null
                
                // Get confidence value from template object for each field
                const templateConfidence = getState()?.temp[fieldKey]?.confidence ?? 
                                          getState()?.fieldDetails[fieldKey]?.confidence ?? 
                                          null

                // Get instructions from template object for each field
                const fieldInstructions = getState()?.temp[fieldKey]?.instructions ?? 
                                        getState()?.fieldDetails[fieldKey]?.instructions ?? 
                                        null

                // Compare template confidence with imgResponse confidence
                // If template confidence > imgResponse confidence, show red, else green (including when equal)
                const getConfidenceColor = () => {
                  if (templateConfidence !== null && imgResponseConfidence !== null) {
                    return templateConfidence >= imgResponseConfidence ? '#f44336' : '#4caf50' // red : green
                  }
                  return '#9e9e9e' // default gray if either is missing
                }

                const errorKey = `${folderName}.${fieldKey}`
                const errorMessage = errors[errorKey]
                const fieldFormat = getFieldFormat(fieldKey)
                const sortedEntries = getSortedFolderEntries(responseData)
                const flatIndex = sortedEntries
                  .slice(0, folderIndex)
                  .reduce((acc, [, fields]) => acc + Object.keys(fields).length, 0)
                  + fieldIndex

                return (
                  <Box
                    key={fieldKey}
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      alignItems: 'left',
                      marginBottom: 1
                    }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        {imgResponseConfidence !== null && imgResponseConfidence !== undefined && (
                          <Box
                            component="span"
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              backgroundColor: getConfidenceColor(),
                              color: 'white',
                              fontSize: '0.7rem',
                              fontWeight: 'medium',
                              minWidth: '45px', // Fixed minimum width to accommodate up to 3 digits + %
                              textAlign: 'center'
                            }}
                          >

                            {imgResponseConfidence}%
                          </Box>
                        )}
                        <Tooltip 
                          title={fieldInstructions || ''}  
                          placement="top"
                          slots={{
                            transition: Fade,
                          }}
                          slotProps={{
                            transition: { timeout: 600 },
                          }}
                          disableHoverListener={!fieldInstructions}
                        >
                          <Typography sx={{ cursor: fieldInstructions ? 'pointer' : 'default' }}>
                            {fieldKey}
                          </Typography>
                        </Tooltip>
                      </Box>
                    </Box>
                    <Tooltip
                      title={errorMessage || ''}
                      disableInteractive
                      slotProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: 'red',
                          }
                        }
                      }}
                      PopperProps={{ disablePortal: true }}
                      open={!!errorMessage}
                      placement='bottom-start'
                    >
                      <TextField
                          size='small'
                          variant='outlined'
                          disabled={disableFields}
                          inputRef={(el) => (inputRefs.current[flatIndex] = el)}
                          inputProps={{
                            maxLength: getState()?.fieldDetails[fieldKey]?.length
                          }}
                          placeholder={isDateField(fieldKey) ? fieldFormat : ''}
                          value={fieldValue}
                          onChange={(e) => {
                            if (isDateField(fieldKey)) {
                              handleDateFieldChange(e, folderName, fieldKey)
                            } else {
                              handleChange(folderName, fieldKey, e.target.value)
                            }
                          }}
                          onKeyDown={(e) => handleKeyDown(e, flatIndex)}
                          error={!!errorMessage}
                          fullWidth
                        />
                      {/* {fieldInstructions && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'text.secondary',
                            fontSize: '0.65rem',
                            fontStyle: 'italic',
                            marginLeft: '4px',
                            lineHeight: 1.2
                          }}
                        >
                          {fieldInstructions}
                        </Typography>
                      )} */}
                    </Tooltip>
                  </Box>
                )
              })}
            </Paper>
          </Box>
        )
      })}

      {getState().isQCCompleted ? (
        <p>{t('smartCatalogLocal.qCAlreadyCompleted')}</p>
      ) : getState().assignedWorker && getState().assignedWorker !== workerId ? (
        <p>{t('smartCatalogLocal.imgAssigned')}</p>
      ) : (
        <Box display="flex" justifyContent='center' gap={1}>
          <GroupedAssetType
            dropDownWidth={100}
            assetTypes={options}
            label={t('dropdowns.actions')}
            value={'selectedAssetTypes'}
            disabled={disableFields}
            onChange={selectChange}
          />

          <OutlinedButton
            style={{ width: '60px', height: '36.5px', margin: '1px', marginTop: '10px' }}
            disabled={disableFields}
            onClick={handleHold}
          >
            buttons.hold
          </OutlinedButton>

          <Button
            style={{ width: '60px', height: '36.5px', margin: '1px', marginTop: '10px' }}
            disabled={disableFields}
            variant='contained'
            onClick={() => handleSubmit(false)}
          >
            {t('buttons.save')}
          </Button>
          <Button
            style={{ width: '130px', height: '36.5px', margin: '1px', marginTop: '10px' }}
            disabled={disableFields}
            variant='contained'
            onClick={() => handleSubmit(true)}
          >
            {t('buttons.cancelAndGoBack')}
          </Button>
        </Box>
      )}
    </Box>
  )
})

export default FieldsInfoContainerD
